import confLabels from './_HslLabels'
import { Base64 } from './Base64.js'

let startOffset = 0
let fetchSize = 200
let allData = []
let dataStore
let eventStore
let $store

function fetchAll (apiEvent, data, store) {
  $store = $store || store
  data = typeof data === 'undefined' ? {} : data
  data.start_offset = startOffset.toString()
  data.fetch_size = fetchSize.toString()
  dataStore = data
  eventStore = apiEvent
  return new Promise((resolve, reject) => {
    $store.dispatch(eventStore, dataStore)
      .then((response) => {
        if (response.data.LastPage === '1') {
          startOffset = 0
          eventStore = ''
          dataStore = {}
          $store = null
          resolve(allData)
        } else if (response.data.LastPage === '0') {
          startOffset += fetchSize
          allData = allData.concat(response.data.list.records)
          fetchAll(eventStore, dataStore)
        }
      })
      .catch((error) => {
        reject(error)
      })
  })
}

function B64ToUTF8 (str) {
  return Base64.Base64.decode(str)
}

function UTF8ToB64 (str) {
  return window.btoa(unescape(encodeURIComponent(str)))
}

function JSONToCSVConvertor (JSONData, ReportTitle, ShowLabel, headings) {
  // If JSONData is not an object then JSON.parse will parse the JSON string in an Object
  var content = typeof JSONData !== 'object' ? JSON.parse(JSONData) : JSONData
  var CSV = ''
  // This condition will generate the Label/Header
  if (ShowLabel) {
    let row = ''
    // This loop will loop round supplied field names in the correct order
    for (let index in headings) {
      // Now convert each value to string and comma-seprated- getting the correct language translation.
      row += HslGetLabel(headings[index]) + ','
    }
    row = row.slice(0, -1)
    // append Label row with line break
    CSV += row + '\r\n'
  }
  // 1st loop is to extract each row
  for (var i = 0; i < content.length; i++) {
    let row = ''
    // 2nd loop will extract each column and convert it in string comma-seprated
    for (let index in headings) {
      // console.log(indexi+" "+headings[indexi])
      row += '"' + content[i][index] + '",'
    }
    row.slice(0, row.length - 1)
    // add a line break after each row
    CSV += row + '\r\n'
  }

  if (CSV === '') {
    return
  }
  save(ReportTitle + '.csv', CSV)
}

function createReportLabel (name) {
  var d = new Date()
  d = d.toLocaleString()
  d = d.split(',')
  d[1] = d[1].substr(0, d[1].lastIndexOf(':'))
  d = d[0] + '' + d[1]
  d = d.replace(new RegExp('/', 'g'), '-')
  return name + ' Export ' + d
}

function createReportsLabel (name) {
  var d = new Date()
  d = d.toLocaleString()
  d = d.split(' ')
  d[1] = d[1].substr(0, d[1].lastIndexOf(':'))
  d = d[0] + '' + d[1]
  d = d.replace(new RegExp('/', 'g'), '-')
  return name + ' Report ' + d
}

function save (filename, data) {
  var blob = new Blob([data], {type: 'text/csv'})

  if (window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveBlob(blob, filename)
  } else {
    var elem = window.document.createElement('a')
    elem.href = window.URL.createObjectURL(blob)
    elem.download = filename
    document.body.appendChild(elem)
    elem.click()
    document.body.removeChild(elem)
  }
}

function HslGetLabel (label) {
  if (confLabels.confLabels[label] !== undefined) {
    return confLabels.confLabels[label]
  } else {
    return label
  }
}

export { fetchAll, B64ToUTF8, UTF8ToB64, JSONToCSVConvertor, createReportLabel, createReportsLabel }
